var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var resolvers = [];
export function registerJSONResolver(resolver) {
    resolvers.push(resolver);
}
export function resolveJSONType(type, props, app) {
    var e_1, _a;
    try {
        for (var resolvers_1 = __values(resolvers), resolvers_1_1 = resolvers_1.next(); !resolvers_1_1.done; resolvers_1_1 = resolvers_1.next()) {
            var resolver = resolvers_1_1.value;
            var node = resolver(type, props, app);
            if (node)
                return node;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (resolvers_1_1 && !resolvers_1_1.done && (_a = resolvers_1.return)) _a.call(resolvers_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
/** Test hook — clear resolver chain. */
export function clearJSONResolvers() {
    resolvers.length = 0;
}
